import { render } from "./PassGen.vue?vue&type=template&id=2e3e34d5"
import script from "./PassGen.vue?vue&type=script&lang=js"
export * from "./PassGen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__